import { ContentChild, Directive, Input, TemplateRef } from "@angular/core";

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "rask-list-column"
})
export class ListColumnDirective {
    @Input() field: string;
    @Input() header: string;
    @Input() sortable = false;

    /**
     * Custom funktion som returnerar en sträng som används vid sorteringjämförelser.
     * Användbart för icke-skalära datatyper
     *
     * @param rowItem Rad i tabellen
     */
    @Input() sortString?: (rowItem: any) => string;
    @Input() width?: string;
    @Input() minWidth?: string;
    @Input() nowrap = false;
    @Input() tooltip = false;
    @Input() centered: boolean;
    @ContentChild(TemplateRef) template: any;
    @ContentChild("headerTemplate") headerTemplate: TemplateRef<any>;
}
